import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import * as logging from './logging';
import * as location from './location';
import * as browser from './browser';
import * as publish from './publish';
import * as jobs from './jobs';
import * as requests from '../requests/reducers';
import * as Sets from '../views/Sets/reducers';
import * as Kits from '../views/Kits/reducers';

export default combineReducers({
  ...logging,
  ...location,
  ...browser,
  ...publish,
  ...jobs,
  ...requests,
  ...Sets,
  ...Kits,
  routing: routerReducer,
});



// WEBPACK FOOTER //
// ./app/javascript/reducers/index.js